import React, { useEffect, useState } from "react";
import "./gputable.css"

const GPUTable = (props) => {
  const { gpuData, activeTab } = props;
  const [loader, setLoader] = useState(true);
  const [currentGPUData, setCurrentGPUData] = useState([]);
 

  useEffect(() => {
    if (gpuData && Object.keys(gpuData).length > 0) {
      const activeTabName = Object.keys(gpuData)[activeTab];
      const currentData = gpuData[activeTabName] || [];
      const filteredData = currentData.filter((item) => item.Region !== "TOTAL");
      const sortedData = [...filteredData].sort((a, b) => a.Region.localeCompare(b.Region));
      setCurrentGPUData(sortedData);
      setLoader(false);
      const allRegionsData = Object.values(gpuData)
      .flat()
      .filter(item => item.Region !== "TOTAL");
    
      const hasInvalidAllocation = allRegionsData.some(item => item.GPUsAllocated > item.Total);
  
      if (hasInvalidAllocation) {
        if (props.capacityAllocation){
          props.setApprovalError("GPUs Allocated cannot be greater than Total GPUs");
        } 
      }else{
          props.setApprovalError("");
      }
    }
  }, [gpuData, activeTab]);

  const midIndex = Math.ceil(currentGPUData.length / 2);
  const firstHalf = currentGPUData.slice(0, midIndex);
  const secondHalf = currentGPUData.slice(midIndex);

  const renderTable = (data) => (
    <table className="gpu-table" style={{ width: "100%" }}>
      <thead>
        <tr style={{ backgroundColor: "#4285F4", color: "white" }}>
          <th className="region-td">Region</th>
          <th>Total</th>
          <th>GPU's Earmarked</th>
          <th>GPU's Committed</th>
          <th>GPU's Allocated</th>
          <th>GPUs Available</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index} className={item.GPUsAllocated > item.Total ? "errorRow" : ""}>
            <td className="region-td">{item.Region}</td>
            <td className="region-td" style={{ textAlign: "center" }}>{item.Total}</td>
            <td style={{ textAlign: "center" }}>{item.GPUsEarmarked || 0}</td>
            <td style={{ textAlign: "center" }}>{item.GPUsCommitted || 0}</td>
            <td style={{ textAlign: "center" }}>{item.GPUsAllocated || 0}</td>
            <td style={{ textAlign: "center" }}>{item.GPUsAvailable}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <>
      {sessionStorage.getItem("tab") === "1" && (
        <div>
          <div className="tabs-container">
            <div className="tabs" style={{ display: "flex" }}>
              {Object.keys(gpuData || {}).map((gpuName, index) => (
                <button
                  key={gpuName}
                  id={index}
                  onClick={() => props.handleTabClick(gpuName, index)}
                  className={index == activeTab ? "all-tabs tabbutton active" : "all-tabs tabbutton"}
                >
                  {gpuName}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      <div className="ptu-available-container" style={{ display: "flex", gap: "20px" }}>
        {currentGPUData.length > 0 && !loader ? (
          <>
            <div style={{ display: "grid", width: "50%" }}>{renderTable(firstHalf)}</div>
            <div style={{ display: "grid", width: "50%" }}>{renderTable(secondHalf)}</div>
          </>
        ) : (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default GPUTable;